<template lang="es">
    <div>
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-row>
                            <v-col cols="12" sm="12" md="7" class="pb-0 mb-0">
                                Administradores Plataforma
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                                 <small v-if="nombreInstitucionUsuario">{{nombreInstitucionUsuario}}</small>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" md="4" sm="4" xs="12">
                        <v-btn v-if="currentRoles.includes(6)"
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Registrar nuevo
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>

                <v-row class="d-flex align-end flex-column mb-4">
                    
                    <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1 align-end">
                        <v-text-field
                            append-icon="mdi-magnify"
                            outlined
                            dense
                            v-model="filtroBusqueda"
                            label="Buscar"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-data-table
                        :headers="headers"
                        :items="usuarios"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="filtroBusqueda"
                        :items-per-page="10"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr v-if="item.estadosId === 1 ">
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombreUsuario }}</td>
                            <td>{{ item.nombreInstitucion }}</td>
                            <td>{{ item.correoUsuario }}</td>
                            <td>{{ item.nombrePuesto }}</td>
                            
                            <td>{{ item.nombreRol }}

                                <div v-for="rol in item.roles">
                                    {{rol.nombreRol}}
                                </div>
                            </td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn v-if="currentRoles.includes(6)" class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <v-btn v-if="currentRoles.includes(6)" class="ma-2" small tile outlined color="indigo" @click="mostrarModalResetPass(item.nombreUsuario, item.id, item.correoUsuario)">
                                    <v-icon left>mdi-lock-reset</v-icon> Restablecer contrase&ntilde;a
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="700px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <!--<v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosUsuario.rolUsuarioId"
                                :items="roles"
                                class="required"
                                dense
                                outlined
                                :loading="dialogLoaderVisible"
                                label="Rol"
                                item-text="nombreRol"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'rol'
                                    )
                                ]"
                            ></v-select>
                        </v-col>-->

                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="rolesSeleccionados"
                                :items="roles"
                                class="required"
                                dense
                                outlined
                                :no-data-text="roles != null ? 'Seleccione los roles' : 'No se han encontrado roles'"
                                label="Seleccionar Rol (es) para el usuario"
                                item-text="nombreRol"
                                item-value="id"
                                multiple
                                return-object
                                chips
                                :rules="multipleSelectRules.required"
                                
                            >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="toggle"
                                    >
                                    <v-list-item-action>
                                        <v-icon :color="rolesSeleccionados.length > 0 ? 'indigo darken-4' : ''">
                                        {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                        Seleccionar todos
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-select>
                        </v-col>

                       

                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosUsuario.puestosId"
                                :items="puestos"
                                class="required"
                                dense
                                outlined
                                :loading="dialogLoaderVisible"
                                label="Puesto"
                                item-text="nombrePuesto"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'puesto'
                                    )
                                ]"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosUsuario.nombreUsuario"
                                label="Nombre del usuario"
                                :rules="[
                                    required(
                                        'Nombre del municipio'
                                    )
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                :disabled="correoDeshabilidato && false"
                                v-model="datosUsuario.correoUsuario"
                                label="Correo electrónico"
                                :rules="[
                                    required(
                                        'Correo usuario'
                                    ),
                                    validEmail('')
                                ]"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                   <!-- <v-row>
                        <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1 d-none">
                            <v-text-field
                                outlined
                                dense
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[required(
                                        'Contraseña'
                                    )]"
                                v-model="datosUsuario.Contrasenia"
                                :type="showPass ? 'text' : 'password'"
                                name="input-10-2"
                                label="Contraseña"
                                hint=""
                                class="input-group--focused"
                                readonly
                                @click:append="showPass = !showPass"
                                maxlength="25"
                            ></v-text-field>
                        </v-col>
                    </v-row> -->

                    
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la etnia-->


    <!-- Inicio:: Dialog para para restablecer contraseña-->
    <v-dialog
        v-model="dialogResetPass"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Restablecer contrase&ntilde;a
                
                <v-spacer></v-spacer>
                <v-btn
                    icon

                    @click="dialogResetPass = false"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                    ref="resetPassForm"
                    v-on:submit.prevent="restablecerContrasenia"
                    >
            <v-card-text>
                <v-container>
                    <h4>Está seguro de restablecer la contrase&ntilde;a para {{nombreInstitucion}}?</h4>
                </v-container>
            </v-card-text>
            <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            :disabled="btnResetPassLoading"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogResetPass = false"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0"
                            :loading="btnResetPassLoading"                           
                        >
                            Restablecer
                        </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    

    <!-- Fin:: Dialog para restablecer contraseña-->
    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import { mapGetters } from "vuex";

import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { RESTABLECER_PASS_USUARIO } from "@/core/services/store/usuarios/usuario.module";
import { OBTENER_USUARIOS_ADMINISTRADORES, OBTENER_USUARIO_INSTITUCION, REGISTRAR_USUARIO_ADMINISTRADOR, ACTUALIZAR_USUARIO_INSTITUCIONAL } from "@/core/services/store/usuarios/usuarioadministrador.module";
//import {RESTABLECER_PASS } from "@/core/services/store/institucion.module";
//import { OBTENER_REGIONES } from "@/core/services/store/region.module";
import { OBTENER_ROLES_ADMINISTRADOR } from "@/core/services/store/rol.module";
import { OBTENER_PUESTOS } from "@/core/services/store/puesto.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminUsuariosInstitucion",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            btnResetPassLoading:false,
            validForm:false,
            itemName : "Usuarios Institucionales",
            dialog: false,
            dialogResetPass:false,
            nombreInstitucion : '',
            nombreInstitucionUsuario: '',
            idInstitucion : 0,
            showPass:false,
            correoDeshabilidato:false,
            modalTitle: 'Registrar Usuario',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Usuario',
            ddPuestosLoading:false,
            ddRolesLoading:false,
            accion: 1,
            Pais_Id: 0,
            roles: [],
            rolesSeleccionados: [],
            puestos:[],
            usuarios: [],
            departamentos: [],
            switchItemEstado: true,
            filtroBusqueda:'',
            datosUsuario: {
                id: 0,
                nombreUsuario: '',
                correoUsuario: '',     
                estadosId: 1,
                rolUsuarioId:0,
                puestosId:0,
                institucionesId: null,
                roles:[]
            },
             datosPass:{
                idUsuario: 0,
                correoUsuario: '',
                usuarioActualizacion: ''
             },
            institucionesId: 0,
            tableLoading: false,
            ...validations,
            multipleSelectRules: {
                
                required: [(v) =>  v.length>0 || "Debes seleccionar roles para el usuario"],
                
            }
        } 
    },
    methods: {

        toggle () {
            this.$nextTick(() => {
            if (this.likesAllRoles) {
                this.rolesSeleccionados = []
            } else {
                this.rolesSeleccionados = this.roles.slice()
            }
            })
        },

        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Usuario';
            this.btnRegistroText='Registrar Usuario';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
            this.datosUsuario={
                id: 0,
                nombreUsuario: '',
                correoUsuario: '',     
                estadosId: 1,
                rolUsuarioId:0,
                institucionesId: null,
                roles:[]
            };
            this.rolesSeleccionados=[];
            this.switchItemEstado = true;
            this.correoDeshabilidato=false;
            this.accion = 1;
        },

        //!Obtener los roles para asignar al usuario
        async obtenerRoles(){
            this.ddRolesLoading =true;
            this.roles=[];
            await this.$store
                .dispatch(OBTENER_ROLES_ADMINISTRADOR)
                .then(res => {
                    if(res.status==200){
                        this.roles = this.$store.state.rol.roles;
                    }
                    this.ddRolesLoading =false;
                    
                })
                .catch(err => {
                    this.ddRolesLoading =false;
                    console.warn(err);
                });
            return;
        },

        //!Obtener los roles para asignar al usuario
        async obtenerPuestos(){
            this.ddPuestosLoading =true;
            this.puestos=[];
            await this.$store
                .dispatch(OBTENER_PUESTOS, 1)
                .then(res => {
                    if(res.status==200){
                        this.puestos = this.$store.state.puesto.puestos;
                    }
                    this.ddPuestosLoading =false;
                //console.log(this.etnias)
                })
                .catch(err => {
                    this.ddPuestosLoading =false;
                    console.warn(err)
                });
        },

        //!Obtener las etnias para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.usuarios=[];
            
            this.$store
                .dispatch(OBTENER_USUARIOS_ADMINISTRADORES,this.institucionesId)
                .then(() => {
                    this.usuarios = this.$store.state.usuarioadministrador.usuariosAdministradores;
                    console.log(this.usuarios);
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosUsuario.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Usuario';
            this.btnRegistroText='Actualizar Usuario';

            this.$store
                .dispatch(OBTENER_USUARIO_INSTITUCION, Id)
                .then(res => {
                    if(res.status===200){
                        this.datosUsuario = this.$store.state.usuarioadministrador.usuarioAdministrador;
                        this.datosUsuario.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.datosUsuario.Contrasenia = 'Segeplan@2021';


                        //!Recorrer los roles del usuario y asignarlos al array de rolesSelecionados para mostrarlos en el dropdown
                        this.rolesSeleccionados = this.datosUsuario.roles.map(function(row) {

                        // This function defines the "mapping behaviour". name and title 
                        // data from each "row" from your columns array is mapped to a 
                        // corresponding item in the new "options" array

                            return { id : row.idRol, nombreRol : row.nombreRol }
                        })

                        //this.rolesSeleccionados = this.datosUsuario.roles.slice()
                        //console.log(this.rolesSeleccionados);
                        //this.obtenerDepartamentos().then(()=>{
                        this.dialog = true;
                       
                        this.correoDeshabilidato=true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', res.message);
                    }
                     this.dialogLoaderVisible = false;
                        
                    //});
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.warn(error)
                });
        },
        
       
        registrarItem(){
            //console.log(this.accion)

           // this.datosUsuario.roles = this.rolesSeleccionados;
           this.datosUsuario.roles = [];

            this.rolesSeleccionados.forEach(element => {
               
                this.datosUsuario.roles.push({idRol: element.id});
            });

            //let newList = Object.assign(this.rolesSeleccionados, element.id)

            // console.log(this.datosUsuario.roles)


            delete this.datosUsuario.municipiosId;
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosUsuario.estadosId = 1 : this.datosUsuario.estadosId = 2;

            if(this.accion===1){
                this.datosUsuario.id = 0;
                this.$store
                    .dispatch(REGISTRAR_USUARIO_ADMINISTRADOR, this.datosUsuario)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_USUARIO_INSTITUCIONAL, this.datosUsuario)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        },
        /**
        * Modal de confirmacion de cambio de contraseña
        */
       mostrarModalResetPass(nombreInstitucion, id, correoUsuario){
           this.dialogResetPass=true;
           this.nombreInstitucion = nombreInstitucion;
           this.idInstitucion = id;
           this.datosPass.idUsuario = id;
           this.datosPass.correoUsuario = correoUsuario;
           this.datosPass.usuarioActualizacion = id.toString();
       },

       /**
        * Restablecer la contraseña del usuario master institucion
        */
       restablecerContrasenia(){
           this.btnResetPassLoading = true;
           this.$store
           .dispatch(RESTABLECER_PASS_USUARIO, this.datosPass)
           .then(res => {
               if(res.status==200){
                   this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                   this.dialogResetPass = false;
               } else {
                   this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error durante la actualización.`);
               }
               this.btnResetPassLoading = false;
            })
           .catch(err => {
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema. REF: ${err}`);
                this.btnResetPassLoading = false;
            });


       }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Inicio", route: "/dashboard" },
            { title: "Instituciones" },
            { title: "Usuarios" }
        ]);
    },

    created(){
       
        let stRoles = window.localStorage.getItem('roles');
        //console.log(stRoles)
        if(stRoles.includes(1)){
            if(parseInt(window.localStorage.getItem('institucionId'))){
                this.datosUsuario.institucionesId = parseInt(window.localStorage.getItem('institucionId'));
                this.nombreInstitucionUsuario = window.localStorage.getItem('institucionNombre');
                this.institucionesId =  parseInt(window.localStorage.getItem('institucionId'));
                
                //this.ddDepartamentoDisabled=true;
                //this.obtnenerMunicipiosPorDepto();
            }
        }

        this.obtnenerItems();
        this.obtenerRoles();
        this.obtenerPuestos();
    },

    computed: {
        ...mapGetters(["currentUser"]),
        ...mapGetters(["currentRoles"]),

        likesAllRoles () {
            return this.rolesSeleccionados.length === this.roles.length
        },
        likesSomeRol () {
            return this.rolesSeleccionados.length > 0 && !this.likesAllRoles
        },
        icon () {
            if (this.likesAllRoles) return 'mdi-close-box'
            if (this.likesSomeRol) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },


        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del usuario",
                    value: "nombreUsuario"
                },
                {
                    text: "Institucion",
                    value: "nombreInstitucion"
                },
                {
                    text: "Correo",
                    value: "correoUsuario"
                },
                {
                    text: "Puesto",
                    value: "nombrePuesto"
                    
                },
                {
                    text: "Rol(es) Asignado(s)",
                    value: "rol"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>